import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, ToastController} from 'ionic-angular';
import {EmailService} from "../../services/email.service";
import {Observable} from "rxjs";
import {ClipboardService} from "ngx-clipboard";
import {tap} from "rxjs/operators";

@IonicPage()
@Component({
  selector: 'page-admin-emails',
  templateUrl: 'admin-emails.html',
})
export class AdminEmailsPage {

  subscriber$: Observable<any>;

  constructor(public navCtrl: NavController,
              private emailService: EmailService,
              private clipboardService: ClipboardService,
              public toastCtrl: ToastController,
              public loadingCtrl: LoadingController,
              public navParams: NavParams) {

    const loader = this.loadingCtrl.create({
      content: "Chargement..."
    });
    loader.present();
    this.subscriber$ =  this.emailService.getAll().pipe(tap(
      ()=> loader.dismissAll()
    ));
  }

  ionViewDidLoad() {
  }

  copyEmailList() {
    this.subscriber$.subscribe( subs => {
      let emailsText = subs.map(sub => sub.id).join(' ');
      this.clipboardService.copyFromContent(emailsText)
      const toast = this.toastCtrl.create({
        message: 'Liste Adresses copiée dans la clipboard',
        duration: 3000
      });
      toast.present();
      }
    );

  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-emails/admin-emails.ts